module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/oee_1@2x-675d0b73bff954acd62ca95eaa52c588.png";